import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const AmericanSamoa: Country = {
    identifier: "AmericanSamoa",
    name: "American Samoa",
    countryCode: "AS",
    group: CountryGroup.OCEANIA,
    isUNMember: false,
    flag: "🇦🇸",
    svgPath: "m 1006.0897,503.3594 -0.121,0.025 -0.144,-0.137 0.28,-0.104 0.089,-0.054 0.34,0.027 -0.203,0.045 z",
}
